import { array, object, string } from "yup";
import isValidCnpj from "../../../../../utils/isValidCnpj";

const opt = () => string().optional().nullable();

export const benefitsSchema = object().shape({
  benefitsIsValidated: string().required("Validado é obrigatório(a)"),

  // Seguro de Vida
  hasLifeInsurance: string().required("Possui seguro de vida é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Possui seguro de vida"),
  lifeInsuranceMovementType: string().when("hasLifeInsurance", {
    is: "1",
    then: string().required("Seguro de vida - Tipo de movimentação é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Seguro de vida - Tipo de movimentação"),
    otherwise: opt(),
  }),
  lifeInsuranceMovementReport: string().when("hasLifeInsurance", {
    is: "1",
    then: string().required("Seguro de vida - Relatório de movimentação é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Seguro de vida - Relatório de movimentação"),
    otherwise: opt(),
  }),
  lifeInsuranceMovementReportDeadline: string().when(["hasLifeInsurance", "lifeInsuranceMovementReport"], {
    is: (hasLifeInsurance, lifeInsuranceMovementReport) => hasLifeInsurance === "1" && lifeInsuranceMovementReport === "1",
    then: string().required("Informe o prazo de envio do relatório"),
    otherwise: opt(),
  }),
  lifeInsuranceDiscountValue: string().when("hasLifeInsurance", {
    is: "1",
    then: string().required("Seguro de vida - Valor do desconto é obrigatório(a)").oneOf(["1", "2", "3"], "Selecione uma opção válida para: Seguro de vida - Valor do desconto"),
    otherwise: opt(),
  }),
  lifeInsuranceDiscountValueFix: string().when(["hasLifeInsurance", "lifeInsuranceDiscountValue"], {
    is: (hasLifeInsurance, lifeInsuranceDiscountValue) => hasLifeInsurance === "1" && lifeInsuranceDiscountValue === "1",
    then: string().required("Informe o valor fixo"),
    otherwise: opt(),
  }),
  lifeInsuranceDiscountValueSalaryPercentage: string().when(["hasLifeInsurance", "lifeInsuranceDiscountValue"], {
    is: (hasLifeInsurance, lifeInsuranceDiscountValue) => hasLifeInsurance === "1" && lifeInsuranceDiscountValue === "2",
    then: string().required("Informe a porcentagem do salário"),
    otherwise: opt(),
  }),
  lifeInsuranceDiscountValueOther: string().when(["hasLifeInsurance", "lifeInsuranceDiscountValue"], {
    is: (hasLifeInsurance, lifeInsuranceDiscountValue) => hasLifeInsurance === "1" && lifeInsuranceDiscountValue === "3",
    then: string().required("Descreva a regra de negócio"),
    otherwise: opt(),
  }),
  lifeInsuranceEmployeeCost: string().when("hasLifeInsurance", {
    is: "1",
    then: string().required("Seguro de vida - Custo do funcionário é obrigatório(a)").test("range-0-100", "Valor deve ser entre 0 e 100", val => !val || (Number(val) >= 0 && Number(val) <= 100)),
    otherwise: opt(),
  }),
  lifeInsuranceCompanyCost: string().when("hasLifeInsurance", {
    is: "1",
    then: string().required("Seguro de vida - Custo da empresa é obrigatório(a)").test("range-0-100", "Valor deve ser entre 0 e 100", val => !val || (Number(val) >= 0 && Number(val) <= 100)),
    otherwise: opt(),
  }),
  lifeInsuranceProLabore: string().when("hasLifeInsurance", {
    is: "1",
    then: string().required("Seguro de vida - pro labore é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Seguro de vida - pro labore"),
    otherwise: opt(),
  }),
  lifeInsuranceIntern: string().when("hasLifeInsurance", {
    is: "1",
    then: string().required("Seguro de vida - Intern é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Seguro de vida - Intern"),
    otherwise: opt(),
  }),
  lifeInsuranceApprentice: string().when("hasLifeInsurance", {
    is: "1",
    then: string().required("Seguro de vida - Apprentice é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Seguro de vida - Apprentice"),
    otherwise: opt(),
  }),
  lifeInsuranceOnLeave: string().when("hasLifeInsurance", {
    is: "1",
    then: string().required("Seguro de vida - Em licença é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Seguro de vida - Em licença"),
    otherwise: opt(),
  }),
  lifeInsuranceDiscountOnPayroll: string().when("hasLifeInsurance", {
    is: "1",
    then: string().required("Seguro de vida - Desconto em folha é obrigatório(a)").oneOf(["1", "2", "3", "4", "5"], "Selecione uma opção válida para: Seguro de vida - Desconto em folha"),
    otherwise: opt(),
  }),
  lifeInsuranceDiscountOnPayrollOther: string().when(["hasLifeInsurance", "lifeInsuranceDiscountOnPayroll"], {
    is: (hasLifeInsurance, lifeInsuranceDiscountOnPayroll) => hasLifeInsurance === "1" && lifeInsuranceDiscountOnPayroll === "5",
    then: string().required("Descreva a regra de negócio"),
    otherwise: opt(),
  }),
  lifeInsuranceDiscountInTermination: string().when("hasLifeInsurance", {
    is: "1",
    then: string().required("Seguro de vida - Desconto na rescisão é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Seguro de vida - Desconto na rescisão"),
    otherwise: opt(),
  }),
  lifeInsuranceOtherRules: string().when("hasLifeInsurance", {
    is: "1",
    then: string().required("Seguro de vida - Outras regras é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Seguro de vida - Outras regras"),
    otherwise: opt(),
  }),
  lifeInsuranceOtherRulesDescription: string().when(["hasLifeInsurance", "lifeInsuranceOtherRules"], {
    is: (hasLifeInsurance, lifeInsuranceOtherRules) => hasLifeInsurance === "1" && lifeInsuranceOtherRules === "1",
    then: string().required("Descreva a regra de negócio"),
    otherwise: opt(),
  }),

  // Plano de Saúde
  hasHealthPlan: string().required("Possui plano de saúde é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Possui plano de saúde"),
  healthPlanOperators: array().when("hasHealthPlan", {
    is: "1",
    then: array().of(
      object().shape({
        name: string().required("Nome da operadora é obrigatório(a)"),
        cnpj: string()
          .required("CNPJ é obrigatório(a)")
          .test("is-cnpj", "O valor não corresponde a um CNPJ válido", value =>
            isValidCnpj(value),
          ),
        ansCode: string().required("Cód. ANS é obrigatório(a)"),
        type: string().required("Tipo de plano é obrigatório(a)").oneOf(["1", "2", "3", "4", "5"], "Selecione uma opção válida para: Type"),
        companyCost: string().required("Custo da empresa é obrigatório(a)"),
        employeeCost: string().required("Custo do colaborador é obrigatório(a)"),
        dependentCost: string().required("Custo do dependente é obrigatório(a)"),
        aggregateCost: string().required("Custo do agregado é obrigatório(a)"),
        hasCoparticipation: string().required("Possui coparticipação é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Has coparticipation"),
        companyCoparticipationCost: string().when("hasCoparticipation", {
          is: "1",
          then: string().required("Custo de coparticipação da empresa é obrigatório(a)"),
          otherwise: opt(),
        }),
        employeeCoparticipationCost: string().when("hasCoparticipation", {
          is: "1",
          then: string().required("Custo de coparticipação do colaborador é obrigatório(a)"),
          otherwise: opt(),
        }),
        dependentCoparticipationCost: string().when("hasCoparticipation", {
          is: "1",
          then: string().required("Custo de coparticipação do dependente é obrigatório(a)"),
          otherwise: opt(),
        }),
        aggregateCoparticipationCost: string().when("hasCoparticipation", {
          is: "1",
          then: string().required("Custo de coparticipação do agregado é obrigatório(a)"),
          otherwise: opt(),
        }),
        coparticipationRule: string().when("hasCoparticipation", {
          is: "1",
          then: string().required("Tabela de coparticipação é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Coparticipation rule"),
          otherwise: opt(),
        }),
        coparticipationRuleDescription: string().when("coparticipationRule", {
          is: "1",
          then: string().required("Descreva a regra de negócio"),
          otherwise: opt(),
        }),
        beneficiariesOutsideEmployees: string().required("Beneficiários fora do quadro de empregados é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Beneficiaries outside employees"),
        beneficiariesOutsideEmployeesDescription: string().when("beneficiariesOutsideEmployees", {
          is: "1",
          then: string().required("Descreva a regra de negócio"),
          otherwise: opt(),
        }),
        reportReceptionDate: string().required("Data de recebimento do relatório é obrigatório(a)"),
        adjustmentDate: string().required("Data de reajuste é obrigatório(a)"),
      })
    ).optional(),
    otherwise: array().optional().nullable(),
  }),
  healthPlanDiscountOnPayroll: string().when("hasHealthPlan", {
    is: "1",
    then: string().required("Plano de saúde - Desconto em folha é obrigatório(a)").oneOf(["1", "2", "3", "4", "5"], "Selecione uma opção válida para: Plano de saúde - Desconto em folha"),
    otherwise: opt(),
  }),
  healthPlanDiscountOnPayrollOther: string().when(["hasHealthPlan", "healthPlanDiscountOnPayroll"], {
    is: (hasHealthPlan, healthPlanDiscountOnPayroll) => hasHealthPlan === "1" && healthPlanDiscountOnPayroll === "5",
    then: string().required("Descreva a regra de negócio"),
    otherwise: opt(),
  }),
  healthPlanDiscountInTermination: string().when("hasHealthPlan", {
    is: "1",
    then: string().required("Plano de saúde - Desconto na rescisão é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Plano de saúde - Desconto na rescisão"),
    otherwise: opt(),
  }),
  healthPlanOtherRules: string().when("hasHealthPlan", {
    is: "1",
    then: string().required("Plano de saúde - Outras regras é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Plano de saúde - Outras regras"),
    otherwise: opt(),
  }),
  healthPlanOtherRulesDescription: string().when(["hasHealthPlan", "healthPlanOtherRules"], {
    is: (hasHealthPlan, healthPlanOtherRules) => hasHealthPlan === "1" && healthPlanOtherRules === "1",
    then: string().required("Descreva a regra de negócio"),
    otherwise: opt(),
  }),

  // Plano Odontológico
  hasDentalPlan: string().required("Possui plano odontológico é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Possui plano odontológico"),
  dentalPlanOperators: array().when("hasDentalPlan", {
    is: "1",
    then: array().of(
      object().shape({
        name: string().required("Nome da operadora é obrigatório(a)"),
        cnpj: string()
          .required("CNPJ é obrigatório(a)")
          .test("is-cnpj", "O valor não corresponde a um CNPJ válido", value =>
            isValidCnpj(value),
          ),
        ansCode: string().required("Cód. ANS é obrigatório(a)"),
        type: string().required("Tipo de plano é obrigatório(a)").oneOf(["1", "2", "3", "4", "5"], "Selecione uma opção válida para: Type"),
        companyCost: string().required("Custo da empresa é obrigatório(a)"),
        employeeCost: string().required("Custo do colaborador é obrigatório(a)"),
        dependentCost: string().required("Custo do dependente é obrigatório(a)"),
        aggregateCost: string().required("Custo do agregado é obrigatório(a)"),
        beneficiariesOutsideEmployees: string().required("Beneficiários fora do quadro de empregados é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Beneficiaries outside employees"),
        beneficiariesOutsideEmployeesDescription: string().when("beneficiariesOutsideEmployees", {
          is: "1",
          then: string().required("Descreva a regra de negócio"),
          otherwise: opt(),
        }),
        reportReceptionDate: string().required("Data de recebimento do relatório é obrigatório(a)"),
        adjustmentDate: string().required("Data de reajuste é obrigatório(a)"),
      })
    ).optional(),
    otherwise: array().optional().nullable(),
  }),
  dentalPlanDiscountOnPayroll: string().when("hasDentalPlan", {
    is: "1",
    then: string().required("Plano odontológico - Desconto em folha é obrigatório(a)").oneOf(["1", "2", "3", "4", "5"], "Selecione uma opção válida para: Plano odontológico - Desconto em folha"),
    otherwise: opt(),
  }),
  dentalPlanDiscountOnPayrollOther: string().when(["hasDentalPlan", "dentalPlanDiscountOnPayroll"], {
    is: (hasDentalPlan, dentalPlanDiscountOnPayroll) => hasDentalPlan === "1" && dentalPlanDiscountOnPayroll === "5",
    then: string().required("Descreva a regra de negócio"),
    otherwise: opt(),
  }),
  dentalPlanDiscountInTermination: string().when("hasDentalPlan", {
    is: "1",
    then: string().required("Plano odontológico - Desconto na rescisão é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Plano odontológico - Desconto na rescisão"),
    otherwise: opt(),
  }),
  dentalPlanOtherRules: string().when("hasDentalPlan", {
    is: "1",
    then: string().required("Plano odontológico - Outras regras é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Plano odontológico - Outras regras"),
    otherwise: opt(),
  }),
  dentalPlanOtherRulesDescription: string().when(["hasDentalPlan", "dentalPlanOtherRules"], {
    is: (hasDentalPlan, dentalPlanOtherRules) => hasDentalPlan === "1" && dentalPlanOtherRules === "1",
    then: string().required("Descreva a regra de negócio"),
    otherwise: opt(),
  }),

  // Vale-Transporte
  hasTransportationVoucher: string().required("Possui vale-transporte é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Possui vale-transporte"),
  transportationOperatorName: string().when("hasTransportationVoucher", {
    is: "1",
    then: string().required("Vale-transporte - operator name é obrigatório(a)"),
    otherwise: opt(),
  }),
  transportationCalculationPeriod: string().when("hasTransportationVoucher", {
    is: "1",
    then: string().required("Vale-transporte - Período de cálculo é obrigatório(a)"),
    otherwise: opt(),
  }),
  transportationDeductionPeriod: string().when("hasTransportationVoucher", {
    is: "1",
    then: string().required("Vale-transporte - Período de desconto é obrigatório(a)"),
    otherwise: opt(),
  }),
  transportationCalcExecution: string().when("hasTransportationVoucher", {
    is: "1",
    then: string().required("Vale-transporte - Execução do cálculo é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Vale-transporte - Execução do cálculo"),
    otherwise: opt(),
  }),
  transportationPurchaseDeadline: string().when("hasTransportationVoucher", {
    is: "1",
    then: string().required("Vale-transporte - Prazo de compra é obrigatório(a)"),
    otherwise: opt(),
  }),
  transportationDeductAbsences: string().when("hasTransportationVoucher", {
    is: "1",
    then: string().required("Vale-transporte - Descontar faltas é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Vale-transporte - Descontar faltas"),
    otherwise: opt(),
  }),
  transportationDeductMedicalCertificates: string().when("hasTransportationVoucher", {
    is: "1",
    then: string().required("Vale-transporte - Descontar atestados médicos é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Vale-transporte - Descontar atestados médicos"),
    otherwise: opt(),
  }),
  transportationBenefitForAccidentLeave: string().when("hasTransportationVoucher", {
    is: "1",
    then: string().required("Vale-transporte - Benefício para licença de acidente é obrigatório(a)").oneOf(["1", "2", "3", "4"], "Selecione uma opção válida para: Vale-transporte - Benefício para licença de acidente"),
    otherwise: opt(),
  }),
  transportationAccidentLeaveLimit: string().when(["hasTransportationVoucher", "transportationBenefitForAccidentLeave"], {
    is: (hasTransportationVoucher, transportationBenefitForAccidentLeave) => hasTransportationVoucher === "1" && transportationBenefitForAccidentLeave === "3",
    then: string().required("Informe o prazo limite"),
    otherwise: opt(),
  }),
  transportationBenefitForAccidentLeaveOther: string().when(["hasTransportationVoucher", "transportationBenefitForAccidentLeave"], {
    is: (hasTransportationVoucher, transportationBenefitForAccidentLeave) => hasTransportationVoucher === "1" && transportationBenefitForAccidentLeave === "1",
    then: string().required("Informe a regra"),
    otherwise: opt(),
  }),
  transportationBenefitForIllnessLeave: string().when("hasTransportationVoucher", {
    is: "1",
    then: string().required("Vale-transporte - Benefício para licença médica é obrigatório(a)").oneOf(["1", "2", "3", "4"], "Selecione uma opção válida para: Vale-transporte - Benefício para licença médica"),
    otherwise: opt(),
  }),
  transportationBenefitForIllnessLeaveLimit: string().when(["hasTransportationVoucher", "transportationBenefitForIllnessLeave"], {
    is: (hasTransportationVoucher, transportationBenefitForIllnessLeave) => hasTransportationVoucher === "1" && transportationBenefitForIllnessLeave === "3",
    then: string().required("Informe o prazo limite"),
    otherwise: opt(),
  }),
  transportationBenefitForIllnessLeaveOther: string().when(["hasTransportationVoucher", "transportationBenefitForIllnessLeave"], {
    is: (hasTransportationVoucher, transportationBenefitForIllnessLeave) => hasTransportationVoucher === "1" && transportationBenefitForIllnessLeave === "1",
    then: string().required("Informe a regra"),
    otherwise: opt(),
  }),
  transportationBenefitForMaternityLeave: string().when("hasTransportationVoucher", {
    is: "1",
    then: string().required("Vale-transporte - Benefício para licença maternidade é obrigatório(a)").oneOf(["1", "2", "3", "4"], "Selecione uma opção válida para: Vale-transporte - Benefício para licença maternidade"),
    otherwise: opt(),
  }),
  transportationBenefitForMaternityLeaveLimit: string().when(["hasTransportationVoucher", "transportationBenefitForMaternityLeave"], {
    is: (hasTransportationVoucher, transportationBenefitForMaternityLeave) => hasTransportationVoucher === "1" && transportationBenefitForMaternityLeave === "3",
    then: string().required("Informe o prazo limite"),
    otherwise: opt(),
  }),
  transportationBenefitForMaternityLeaveOther: string().when(["hasTransportationVoucher", "transportationBenefitForMaternityLeave"], {
    is: (hasTransportationVoucher, transportationBenefitForMaternityLeave) => hasTransportationVoucher === "1" && transportationBenefitForMaternityLeave === "1",
    then: string().required("Informe a regra"),
    otherwise: opt(),
  }),
  transportationBenefitDuringVacation: string().when("hasTransportationVoucher", {
    is: "1",
    then: string().required("Vale-transporte - Benefício durante férias é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Vale-transporte - Benefício durante férias"),
    otherwise: opt(),
  }),
  transportationOtherDeductionFactors: string().when("hasTransportationVoucher", {
    is: "1",
    then: string().required("Vale-transporte - Outros fatores de desconto é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Vale-transporte - Outros fatores de desconto"),
    otherwise: opt(),
  }),
  transportationDeductionRuleDescription: string().when(["hasTransportationVoucher", "transportationOtherDeductionFactors"], {
    is: (hasTransportationVoucher, transportationOtherDeductionFactors) => hasTransportationVoucher === "1" && transportationOtherDeductionFactors === "1",
    then: string().required("Descreva a regra de negócio"),
    otherwise: opt(),
  }),
  transportationPayrollDeduction: string().when("hasTransportationVoucher", {
    is: "1",
    then: string().required("Vale-transporte - Desconto em folha é obrigatório(a)").oneOf(["1", "2", "3", "4", "5"], "Selecione uma opção válida para: Vale-transporte - Desconto em folha"),
    otherwise: opt(),
  }),
  transportationPayrollDeductionOther: string().when(["hasTransportationVoucher", "transportationPayrollDeduction"], {
    is: (hasTransportationVoucher, transportationPayrollDeduction) => hasTransportationVoucher === "1" && transportationPayrollDeduction === "5",
    then: string().required("Descreva a regra de negócio"),
    otherwise: opt(),
  }),
  transportationTerminationDeduction: string().when("hasTransportationVoucher", {
    is: "1",
    then: string().required("Vale-transporte - Desconto na rescisão é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Vale-transporte - Desconto na rescisão"),
    otherwise: opt(),
  }),
  transportationUnusedBenefitDeduction: string().when("hasTransportationVoucher", {
    is: "1",
    then: string().required("Vale-transporte - Desconto de benefício não utilizado é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Vale-transporte - Desconto de benefício não utilizado"),
    otherwise: opt(),
  }),

  // Vale-Mobilidade
  hasMobilityVoucher: string().required("Possui vale-mobilidade é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Possui vale-mobilidade"),
  mobilityOperatorName: string().when("hasMobilityVoucher", {
    is: "1",
    then: string().required("Vale-mobilidade - operator name é obrigatório(a)"),
    otherwise: opt(),
  }),
  mobilityCalculationPeriod: string().when("hasMobilityVoucher", {
    is: "1",
    then: string().required("Vale-mobilidade - Período de cálculo é obrigatório(a)"),
    otherwise: opt(),
  }),
  mobilityDeductionPeriod: string().when("hasMobilityVoucher", {
    is: "1",
    then: string().required("Vale-mobilidade - Período de desconto é obrigatório(a)"),
    otherwise: opt(),
  }),
  mobilityCalcExecution: string().when("hasMobilityVoucher", {
    is: "1",
    then: string().required("Vale-mobilidade - Execução do cálculo é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Vale-mobilidade - Execução do cálculo"),
    otherwise: opt(),
  }),
  mobilityPurchaseDeadline: string().when("hasMobilityVoucher", {
    is: "1",
    then: string().required("Vale-mobilidade - Prazo de compra é obrigatório(a)"),
    otherwise: opt(),
  }),
  mobilityDeductAbsences: string().when("hasMobilityVoucher", {
    is: "1",
    then: string().required("Vale-mobilidade - Descontar faltas é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Vale-mobilidade - Descontar faltas"),
    otherwise: opt(),
  }),
  mobilityDeductMedicalCertificates: string().when("hasMobilityVoucher", {
    is: "1",
    then: string().required("Vale-mobilidade - Descontar atestados médicos é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Vale-mobilidade - Descontar atestados médicos"),
    otherwise: opt(),
  }),
  mobilityBenefitForAccidentLeave: string().when("hasMobilityVoucher", {
    is: "1",
    then: string().required("Vale-mobilidade - Benefício para licença de acidente é obrigatório(a)").oneOf(["1", "2", "3", "4"], "Selecione uma opção válida para: Vale-mobilidade - Benefício para licença de acidente"),
    otherwise: opt(),
  }),
  mobilityAccidentLeaveLimit: string().when(["hasMobilityVoucher", "mobilityBenefitForAccidentLeave"], {
    is: (hasMobilityVoucher, mobilityBenefitForAccidentLeave) => hasMobilityVoucher === "1" && mobilityBenefitForAccidentLeave === "3",
    then: string().required("Informe o prazo limite"),
    otherwise: opt(),
  }),
  mobilityBenefitForAccidentLeaveOther: string().when(["hasMobilityVoucher", "mobilityBenefitForAccidentLeave"], {
    is: (hasMobilityVoucher, mobilityBenefitForAccidentLeave) => hasMobilityVoucher === "1" && mobilityBenefitForAccidentLeave === "1",
    then: string().required("Informe a regra"),
    otherwise: opt(),
  }),
  mobilityBenefitForIllnessLeave: string().when("hasMobilityVoucher", {
    is: "1",
    then: string().required("Vale-mobilidade - Benefício para licença médica é obrigatório(a)").oneOf(["1", "2", "3", "4"], "Selecione uma opção válida para: Vale-mobilidade - Benefício para licença médica"),
    otherwise: opt(),
  }),
  mobilityBenefitForIllnessLeaveLimit: string().when(["hasMobilityVoucher", "mobilityBenefitForIllnessLeave"], {
    is: (hasMobilityVoucher, mobilityBenefitForIllnessLeave) => hasMobilityVoucher === "1" && mobilityBenefitForIllnessLeave === "3",
    then: string().required("Informe o prazo limite"),
    otherwise: opt(),
  }),
  mobilityBenefitForIllnessLeaveOther: string().when(["hasMobilityVoucher", "mobilityBenefitForIllnessLeave"], {
    is: (hasMobilityVoucher, mobilityBenefitForIllnessLeave) => hasMobilityVoucher === "1" && mobilityBenefitForIllnessLeave === "1",
    then: string().required("Informe a regra"),
    otherwise: opt(),
  }),
  mobilityBenefitForMaternityLeave: string().when("hasMobilityVoucher", {
    is: "1",
    then: string().required("Vale-mobilidade - Benefício para licença maternidade é obrigatório(a)").oneOf(["1", "2", "3", "4"], "Selecione uma opção válida para: Vale-mobilidade - Benefício para licença maternidade"),
    otherwise: opt(),
  }),
  mobilityBenefitForMaternityLeaveLimit: string().when(["hasMobilityVoucher", "mobilityBenefitForMaternityLeave"], {
    is: (hasMobilityVoucher, mobilityBenefitForMaternityLeave) => hasMobilityVoucher === "1" && mobilityBenefitForMaternityLeave === "3",
    then: string().required("Informe o prazo limite"),
    otherwise: opt(),
  }),
  mobilityBenefitForMaternityLeaveOther: string().when(["hasMobilityVoucher", "mobilityBenefitForMaternityLeave"], {
    is: (hasMobilityVoucher, mobilityBenefitForMaternityLeave) => hasMobilityVoucher === "1" && mobilityBenefitForMaternityLeave === "1",
    then: string().required("Informe a regra"),
    otherwise: opt(),
  }),
  mobilityBenefitDuringVacation: string().when("hasMobilityVoucher", {
    is: "1",
    then: string().required("Vale-mobilidade - Benefício durante férias é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Vale-mobilidade - Benefício durante férias"),
    otherwise: opt(),
  }),
  mobilityOtherDeductionFactors: string().when("hasMobilityVoucher", {
    is: "1",
    then: string().required("Vale-mobilidade - Outros fatores de desconto é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Vale-mobilidade - Outros fatores de desconto"),
    otherwise: opt(),
  }),
  mobilityDeductionRuleDescription: string().when(["hasMobilityVoucher", "mobilityOtherDeductionFactors"], {
    is: (hasMobilityVoucher, mobilityOtherDeductionFactors) => hasMobilityVoucher === "1" && mobilityOtherDeductionFactors === "1",
    then: string().required("Descreva a regra de negócio"),
    otherwise: opt(),
  }),
  mobilityPayrollDeduction: string().when("hasMobilityVoucher", {
    is: "1",
    then: string().required("Vale-mobilidade - Desconto em folha é obrigatório(a)").oneOf(["1", "2", "3", "4", "5"], "Selecione uma opção válida para: Vale-mobilidade - Desconto em folha"),
    otherwise: opt(),
  }),
  mobilityPayrollDeductionOther: string().when(["hasMobilityVoucher", "mobilityPayrollDeduction"], {
    is: (hasMobilityVoucher, mobilityPayrollDeduction) => hasMobilityVoucher === "1" && mobilityPayrollDeduction === "5",
    then: string().required("Descreva a regra de negócio"),
    otherwise: opt(),
  }),
  mobilityTerminationDeduction: string().when("hasMobilityVoucher", {
    is: "1",
    then: string().required("Vale-mobilidade - Desconto na rescisão é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Vale-mobilidade - Desconto na rescisão"),
    otherwise: opt(),
  }),
  mobilityUnusedBenefitDeduction: string().when("hasMobilityVoucher", {
    is: "1",
    then: string().required("Vale-mobilidade - Desconto de benefício não utilizado é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Vale-mobilidade - Desconto de benefício não utilizado"),
    otherwise: opt(),
  }),

  // Vale-Alimentação
  hasFoodVoucher: string().required("Possui vale-alimentação é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Possui vale-alimentação"),
  foodOperatorName: string().when("hasFoodVoucher", {
    is: "1",
    then: string().required("Vale-alimentação - operator name é obrigatório(a)"),
    otherwise: opt(),
  }),
  foodCalculationPeriod: string().when("hasFoodVoucher", {
    is: "1",
    then: string().required("Vale-alimentação - Período de cálculo é obrigatório(a)"),
    otherwise: opt(),
  }),
  foodDeductionPeriod: string().when("hasFoodVoucher", {
    is: "1",
    then: string().required("Vale-alimentação - Período de desconto é obrigatório(a)"),
    otherwise: opt(),
  }),
  foodCalcExecution: string().when("hasFoodVoucher", {
    is: "1",
    then: string().required("Vale-alimentação - Execução do cálculo é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Vale-alimentação - Execução do cálculo"),
    otherwise: opt(),
  }),
  foodPurchaseDeadline: string().when("hasFoodVoucher", {
    is: "1",
    then: string().required("Vale-alimentação - Prazo de compra é obrigatório(a)"),
    otherwise: opt(),
  }),
  foodDeductAbsences: string().when("hasFoodVoucher", {
    is: "1",
    then: string().required("Vale-alimentação - Descontar faltas é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Vale-alimentação - Descontar faltas"),
    otherwise: opt(),
  }),
  foodDeductMedicalCertificates: string().when("hasFoodVoucher", {
    is: "1",
    then: string().required("Vale-alimentação - Descontar atestados médicos é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Vale-alimentação - Descontar atestados médicos"),
    otherwise: opt(),
  }),
  foodBenefitForAccidentLeave: string().when("hasFoodVoucher", {
    is: "1",
    then: string().required("Vale-alimentação - Benefício para licença de acidente é obrigatório(a)").oneOf(["1", "2", "3", "4"], "Selecione uma opção válida para: Vale-alimentação - Benefício para licença de acidente"),
    otherwise: opt(),
  }),
  foodAccidentLeaveLimit: string().when(["hasFoodVoucher", "foodBenefitForAccidentLeave"], {
    is: (hasFoodVoucher, foodBenefitForAccidentLeave) => hasFoodVoucher === "1" && foodBenefitForAccidentLeave === "3",
    then: string().required("Informe o prazo limite"),
    otherwise: opt(),
  }),
  foodBenefitForAccidentLeaveOther: string().when(["hasFoodVoucher", "foodBenefitForAccidentLeave"], {
    is: (hasFoodVoucher, foodBenefitForAccidentLeave) => hasFoodVoucher === "1" && foodBenefitForAccidentLeave === "1",
    then: string().required("Informe a regra"),
    otherwise: opt(),
  }),
  foodBenefitForIllnessLeave: string().when("hasFoodVoucher", {
    is: "1",
    then: string().required("Vale-alimentação - Benefício para licença médica é obrigatório(a)").oneOf(["1", "2", "3", "4"], "Selecione uma opção válida para: Vale-alimentação - Benefício para licença médica"),
    otherwise: opt(),
  }),
  foodBenefitForIllnessLeaveLimit: string().when(["hasFoodVoucher", "foodBenefitForIllnessLeave"], {
    is: (hasFoodVoucher, foodBenefitForIllnessLeave) => hasFoodVoucher === "1" && foodBenefitForIllnessLeave === "3",
    then: string().required("Informe o prazo limite"),
    otherwise: opt(),
  }),
  foodBenefitForIllnessLeaveOther: string().when(["hasFoodVoucher", "foodBenefitForIllnessLeave"], {
    is: (hasFoodVoucher, foodBenefitForIllnessLeave) => hasFoodVoucher === "1" && foodBenefitForIllnessLeave === "1",
    then: string().required("Informe a regra"),
    otherwise: opt(),
  }),
  foodBenefitForMaternityLeave: string().when("hasFoodVoucher", {
    is: "1",
    then: string().required("Vale-alimentação - Benefício para licença maternidade é obrigatório(a)").oneOf(["1", "2", "3", "4"], "Selecione uma opção válida para: Vale-alimentação - Benefício para licença maternidade"),
    otherwise: opt(),
  }),
  foodBenefitForMaternityLeaveLimit: string().when(["hasFoodVoucher", "foodBenefitForMaternityLeave"], {
    is: (hasFoodVoucher, foodBenefitForMaternityLeave) => hasFoodVoucher === "1" && foodBenefitForMaternityLeave === "3",
    then: string().required("Informe o prazo limite"),
    otherwise: opt(),
  }),
  foodBenefitForMaternityLeaveOther: string().when(["hasFoodVoucher", "foodBenefitForMaternityLeave"], {
    is: (hasFoodVoucher, foodBenefitForMaternityLeave) => hasFoodVoucher === "1" && foodBenefitForMaternityLeave === "1",
    then: string().required("Informe a regra"),
    otherwise: opt(),
  }),
  foodBenefitDuringVacation: string().when("hasFoodVoucher", {
    is: "1",
    then: string().required("Vale-alimentação - Benefício durante férias é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Vale-alimentação - Benefício durante férias"),
    otherwise: opt(),
  }),
  foodOtherDeductionFactors: string().when("hasFoodVoucher", {
    is: "1",
    then: string().required("Vale-alimentação - Outros fatores de desconto é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Vale-alimentação - Outros fatores de desconto"),
    otherwise: opt(),
  }),
  foodDeductionRuleDescription: string().when(["hasFoodVoucher", "foodOtherDeductionFactors"], {
    is: (hasFoodVoucher, foodOtherDeductionFactors) => hasFoodVoucher === "1" && foodOtherDeductionFactors === "1",
    then: string().required("Descreva a regra de negócio"),
    otherwise: opt(),
  }),
  foodPayrollDeduction: string().when("hasFoodVoucher", {
    is: "1",
    then: string().required("Vale-alimentação - Desconto em folha é obrigatório(a)").oneOf(["1", "2", "3", "4", "5"], "Selecione uma opção válida para: Vale-alimentação - Desconto em folha"),
    otherwise: opt(),
  }),
  foodPayrollDeductionOther: string().when(["hasFoodVoucher", "foodPayrollDeduction"], {
    is: (hasFoodVoucher, foodPayrollDeduction) => hasFoodVoucher === "1" && foodPayrollDeduction === "5",
    then: string().required("Descreva a regra de negócio"),
    otherwise: opt(),
  }),
  foodTerminationDeduction: string().when("hasFoodVoucher", {
    is: "1",
    then: string().required("Vale-alimentação - Desconto na rescisão é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Vale-alimentação - Desconto na rescisão"),
    otherwise: opt(),
  }),
  foodUnusedBenefitDeduction: string().when("hasFoodVoucher", {
    is: "1",
    then: string().required("Vale-alimentação - Desconto de benefício não utilizado é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Vale-alimentação - Desconto de benefício não utilizado"),
    otherwise: opt(),
  }),

  // Vale-Refeição
  hasMealVoucher: string().required("Possui vale-refeição é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Possui vale-refeição"),
  mealOperatorName: string().when("hasMealVoucher", {
    is: "1",
    then: string().required("Vale-refeição - operator name é obrigatório(a)"),
    otherwise: opt(),
  }),
  mealCalculationPeriod: string().when("hasMealVoucher", {
    is: "1",
    then: string().required("Vale-refeição - Período de cálculo é obrigatório(a)"),
    otherwise: opt(),
  }),
  mealDeductionPeriod: string().when("hasMealVoucher", {
    is: "1",
    then: string().required("Vale-refeição - Período de desconto é obrigatório(a)"),
    otherwise: opt(),
  }),
  mealCalcExecution: string().when("hasMealVoucher", {
    is: "1",
    then: string().required("Vale-refeição - Execução do cálculo é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Vale-refeição - Execução do cálculo"),
    otherwise: opt(),
  }),
  mealPurchaseDeadline: string().when("hasMealVoucher", {
    is: "1",
    then: string().required("Vale-refeição - Prazo de compra é obrigatório(a)"),
    otherwise: opt(),
  }),
  mealDeductAbsences: string().when("hasMealVoucher", {
    is: "1",
    then: string().required("Vale-refeição - Descontar faltas é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Vale-refeição - Descontar faltas"),
    otherwise: opt(),
  }),
  mealDeductMedicalCertificates: string().when("hasMealVoucher", {
    is: "1",
    then: string().required("Vale-refeição - Descontar atestados médicos é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Vale-refeição - Descontar atestados médicos"),
    otherwise: opt(),
  }),
  mealBenefitForAccidentLeave: string().when("hasMealVoucher", {
    is: "1",
    then: string().required("Vale-refeição - Benefício para licença de acidente é obrigatório(a)").oneOf(["1", "2", "3", "4"], "Selecione uma opção válida para: Vale-refeição - Benefício para licença de acidente"),
    otherwise: opt(),
  }),
  mealAccidentLeaveLimit: string().when(["hasMealVoucher", "mealBenefitForAccidentLeave"], {
    is: (hasMealVoucher, mealBenefitForAccidentLeave) => hasMealVoucher === "1" && mealBenefitForAccidentLeave === "3",
    then: string().required("Informe o prazo limite"),
    otherwise: opt(),
  }),
  mealBenefitForAccidentLeaveOther: string().when(["hasMealVoucher", "mealBenefitForAccidentLeave"], {
    is: (hasMealVoucher, mealBenefitForAccidentLeave) => hasMealVoucher === "1" && mealBenefitForAccidentLeave === "1",
    then: string().required("Informe a regra"),
    otherwise: opt(),
  }),
  mealBenefitForIllnessLeave: string().when("hasMealVoucher", {
    is: "1",
    then: string().required("Vale-refeição - Benefício para licença médica é obrigatório(a)").oneOf(["1", "2", "3", "4"], "Selecione uma opção válida para: Vale-refeição - Benefício para licença médica"),
    otherwise: opt(),
  }),
  mealBenefitForIllnessLeaveLimit: string().when(["hasMealVoucher", "mealBenefitForIllnessLeave"], {
    is: (hasMealVoucher, mealBenefitForIllnessLeave) => hasMealVoucher === "1" && mealBenefitForIllnessLeave === "3",
    then: string().required("Informe o prazo limite"),
    otherwise: opt(),
  }),
  mealBenefitForIllnessLeaveOther: string().when(["hasMealVoucher", "mealBenefitForIllnessLeave"], {
    is: (hasMealVoucher, mealBenefitForIllnessLeave) => hasMealVoucher === "1" && mealBenefitForIllnessLeave === "1",
    then: string().required("Informe a regra"),
    otherwise: opt(),
  }),
  mealBenefitForMaternityLeave: string().when("hasMealVoucher", {
    is: "1",
    then: string().required("Vale-refeição - Benefício para licença maternidade é obrigatório(a)").oneOf(["1", "2", "3", "4"], "Selecione uma opção válida para: Vale-refeição - Benefício para licença maternidade"),
    otherwise: opt(),
  }),
  mealBenefitForMaternityLeaveLimit: string().when(["hasMealVoucher", "mealBenefitForMaternityLeave"], {
    is: (hasMealVoucher, mealBenefitForMaternityLeave) => hasMealVoucher === "1" && mealBenefitForMaternityLeave === "3",
    then: string().required("Informe o prazo limite"),
    otherwise: opt(),
  }),
  mealBenefitForMaternityLeaveOther: string().when(["hasMealVoucher", "mealBenefitForMaternityLeave"], {
    is: (hasMealVoucher, mealBenefitForMaternityLeave) => hasMealVoucher === "1" && mealBenefitForMaternityLeave === "1",
    then: string().required("Informe a regra"),
    otherwise: opt(),
  }),
  mealBenefitDuringVacation: string().when("hasMealVoucher", {
    is: "1",
    then: string().required("Vale-refeição - Benefício durante férias é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Vale-refeição - Benefício durante férias"),
    otherwise: opt(),
  }),
  mealOtherDeductionFactors: string().when("hasMealVoucher", {
    is: "1",
    then: string().required("Vale-refeição - Outros fatores de desconto é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Vale-refeição - Outros fatores de desconto"),
    otherwise: opt(),
  }),
  mealDeductionRuleDescription: string().when(["hasMealVoucher", "mealOtherDeductionFactors"], {
    is: (hasMealVoucher, mealOtherDeductionFactors) => hasMealVoucher === "1" && mealOtherDeductionFactors === "1",
    then: string().required("Descreva a regra de negócio"),
    otherwise: opt(),
  }),
  mealPayrollDeduction: string().when("hasMealVoucher", {
    is: "1",
    then: string().required("Vale-refeição - Desconto em folha é obrigatório(a)").oneOf(["1", "2", "3", "4", "5"], "Selecione uma opção válida para: Vale-refeição - Desconto em folha"),
    otherwise: opt(),
  }),
  mealPayrollDeductionOther: string().when(["hasMealVoucher", "mealPayrollDeduction"], {
    is: (hasMealVoucher, mealPayrollDeduction) => hasMealVoucher === "1" && mealPayrollDeduction === "5",
    then: string().required("Descreva a regra de negócio"),
    otherwise: opt(),
  }),
  mealTerminationDeduction: string().when("hasMealVoucher", {
    is: "1",
    then: string().required("Vale-refeição - Desconto na rescisão é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Vale-refeição - Desconto na rescisão"),
    otherwise: opt(),
  }),
  mealUnusedBenefitDeduction: string().when("hasMealVoucher", {
    is: "1",
    then: string().required("Vale-refeição - Desconto de benefício não utilizado é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Vale-refeição - Desconto de benefício não utilizado"),
    otherwise: opt(),
  }),

  // Cesta Básica
  hasBasicBasket: string().required("Possui cesta básica é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Possui cesta básica"),
  basicBasketProvider: string().when("hasBasicBasket", {
    is: "1",
    then: string().required("Cesta básica - Provider é obrigatório(a)"),
    otherwise: opt(),
  }),
  basicBasketCalculationPeriod: string().when("hasBasicBasket", {
    is: "1",
    then: string().required("Cesta básica - Período de cálculo é obrigatório(a)"),
    otherwise: opt(),
  }),
  basicBasketBusinessRule: string().when("hasBasicBasket", {
    is: "1",
    then: string().required("Cesta básica - business rule é obrigatório(a)"),
    otherwise: opt(),
  }),
  basicBasketPayrollDeduction: string().when("hasBasicBasket", {
    is: "1",
    then: string().required("Cesta básica - Desconto em folha é obrigatório(a)").oneOf(["1", "2", "3", "4", "5"], "Selecione uma opção válida para: Cesta básica - Desconto em folha"),
    otherwise: opt(),
  }),
  basicBasketPayrollDeductionOther: string().when(["hasBasicBasket", "basicBasketPayrollDeduction"], {
    is: (hasBasicBasket, basicBasketPayrollDeduction) => hasBasicBasket === "1" && basicBasketPayrollDeduction === "5",
    then: string().required("Descreva a regra de negócio"),
    otherwise: opt(),
  }),
  basicBasketTerminationDeduction: string().when("hasBasicBasket", {
    is: "1",
    then: string().required("Cesta básica - Desconto na rescisão é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Cesta básica - Desconto na rescisão"),
    otherwise: opt(),
  }),
  basicBasketUnusedBenefitDeduction: string().when("hasBasicBasket", {
    is: "1",
    then: string().required("Cesta básica - Desconto de benefício não utilizado é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Cesta básica - Desconto de benefício não utilizado"),
    otherwise: opt(),
  }),

  // Refeitório
  hasCanteen: string().required("Possui refeitório é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Possui refeitório"),
  canteenCalculationPeriod: string().when("hasCanteen", {
    is: "1",
    then: string().required("Refeitório - Período de cálculo é obrigatório(a)"),
    otherwise: opt(),
  }),
  canteenBusinessRule: string().when("hasCanteen", {
    is: "1",
    then: string().required("Refeitório - business rule é obrigatório(a)"),
    otherwise: opt(),
  }),
  canteenPayrollDeduction: string().when("hasCanteen", {
    is: "1",
    then: string().required("Refeitório - Desconto em folha é obrigatório(a)").oneOf(["1", "2", "3", "4", "5"], "Selecione uma opção válida para: Refeitório - Desconto em folha"),
    otherwise: opt(),
  }),
  canteenPayrollDeductionOther: string().when(["hasCanteen", "canteenPayrollDeduction"], {
    is: (hasCanteen, canteenPayrollDeduction) => hasCanteen === "1" && canteenPayrollDeduction === "5",
    then: string().required("Descreva a regra de negócio"),
    otherwise: opt(),
  }),
  canteenTerminationDeduction: string().when("hasCanteen", {
    is: "1",
    then: string().required("Refeitório - Desconto na rescisão é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Refeitório - Desconto na rescisão"),
    otherwise: opt(),
  }),
  canteenUnusedBenefitDeduction: string().when("hasCanteen", {
    is: "1",
    then: string().required("Refeitório - Desconto de benefício não utilizado é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Refeitório - Desconto de benefício não utilizado"),
    otherwise: opt(),
  }),

  // Outros Benefícios
  hasOtherBenefits: string().required("Possui outros benefícios é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Possui outros benefícios"),
  otherBenefits: array().when("hasOtherBenefits", {
    is: "1",
    then: array()
      .of(
        object().shape({
          description: string().required("Descrição é obrigatório(a)"),
          businessRule: string().required("Regra de negócio é obrigatório(a)"),
        })
      )
      .min(1, "Adicione pelo menos um benefício"),
    otherwise: array().optional().nullable(),
  }),

  // Convênio
  hasPharmacy: string().required("Possui convênio é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Possui convênio"),
  agreements: array().when("hasPharmacy", {
    is: "1",
    then: array()
      .of(
        object().shape({
          description: string().required("Descrição é obrigatório(a)"),
          calculationPeriod: string().required("Período de cálculo é obrigatório(a)"),
          infoFormat: string().required("Formato das informações é obrigatório(a)").oneOf(["1", "2", "3", "4"], "Selecione uma opção válida para: Formato das informações"),
          reportDeadline: string().required("Prazo de envio do relatório é obrigatório(a)"),
          payrollDeduction: string().required("Desconto em folha é obrigatório(a)").oneOf(["1", "2", "3", "4", "5"], "Selecione uma opção válida para: Desconto em folha"),
          payrollDeductionOther: string().when("payrollDeduction", {
            is: "5",
            then: string().required("Descreva a regra de negócio"),
            otherwise: opt(),
          }),
          terminationDeduction: string().required("Desconto na rescisão é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Desconto na rescisão"),
          unusedBenefitDeduction: string().required("Desconto de benefício não utilizado é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Desconto de benefício não utilizado"),
        })
      )
      .min(1, "Adicione pelo menos um convênio"),
    otherwise: array().optional().nullable(),
  }),

  // Acessos | Procuração
  hasSocialSecurity: string().required("Possui acesso INSS é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Possui acesso INSS"),
  socialSecurityUser: string().when("hasSocialSecurity", {
    is: "1",
    then: string().required("Usuário do INSS é obrigatório(a)"),
    otherwise: opt(),
  }),
  socialSecurityPassword: string().when("hasSocialSecurity", {
    is: "1",
    then: string().required("Senha do INSS é obrigatório(a)"),
    otherwise: opt(),
  }),
  hasPowerOfAttorney: string().required("Possui procuração é obrigatório(a)").oneOf(["1", "2"], "Selecione uma opção válida para: Possui procuração"),
  eSocialPowerOfAttorneyExpirationDate: string().when("hasPowerOfAttorney", {
    is: "1",
    then: string().required("Vencimento da procuração do eSocial é obrigatório(a)"),
    otherwise: opt(),
  }),
  connectivityPowerOfAttorneyExpirationDate: string().when("hasPowerOfAttorney", {
    is: "1",
    then: string().required("Vencimento da procuração do Conectividade é obrigatório(a)"),
    otherwise: opt(),
  }),
  employerWebPowerOfAttorneyExpirationDate: string().when("hasPowerOfAttorney", {
    is: "1",
    then: string().required("Vencimento da procuração do Empregador Web é obrigatório(a)"),
    otherwise: opt(),
  }),
});
